import React, { useEffect } from 'react';
import {
    Bouton,
    InputMi,
    Container,
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    GroupeBouton,
    Col,
    Row,
} from '@design-system-etat/dsfr-react';
import { useForm } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_RECUPER_LOGIN_DEMANDE,
    CONTEXT_RECUPER_LOGIN_DEMANDE,
} from '../../../../constants/apiUrls.constants';
import { REGEXP_EMAIL } from '../../../../constants/contraintes.constants';

const DemandeLoginOublie = ({ postApi, reinitialiseApi, erreur, message, isLoading }) => {
    const { register, handleSubmit, formState } = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });

    const redirigerVersAccueil = () => {
        window.location.href = process.env.REACT_APP_HOST;
    };

    useEffect(() => {
        return () => {
            reinitialiseApi(CONTEXT_RECUPER_LOGIN_DEMANDE);
        };
    }, []);

    const onSubmit = (messageForm) => {
        postApi(
            usagerClientReducer,
            API_RECUPER_LOGIN_DEMANDE.replace('{email}', messageForm.email),
            {},
            CONTEXT_RECUPER_LOGIN_DEMANDE,
        );
    };

    return (
        <Container>
            {!isLoading && !erreur && message && (
                <Modale closeCallback={redirigerVersAccueil} taille="sm">
                    <ModaleTitre>Récupération de Login</ModaleTitre>
                    <ModaleContent>{message}</ModaleContent>
                    <ModaleFooter>
                        <GroupeBouton alignementHorizontal="right" isHorizontal>
                            <Bouton
                                label="Retour à la page de connexion"
                                niveau="primaire"
                                onClick={redirigerVersAccueil}
                            />
                        </GroupeBouton>
                    </ModaleFooter>
                </Modale>
            )}

            <h1 className="text-center majuscule">Identifiant Oublié</h1>
            <div className="bordure">
                <h2 className="font-size-md text-center margin-top-sm margin-bottom-md">
                    Vous avez perdu votre identifiant. Veuillez suivre la procédure ci-dessous pour
                    le récupérer
                </h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row goutierre alignementHorizontal="center" className="margin-bottom-md">
                        <Col col={12} md={8}>
                            <InputMi
                                label="Veuillez saisir votre courriel"
                                type="text"
                                required
                                {...register('email', {
                                    required: 'Le champ est obligatoire',
                                    pattern: {
                                        value: REGEXP_EMAIL,
                                        message: "Le format de l'adresse courriel n'est pas valide",
                                    },
                                })}
                                error={formState.errors ? formState.errors.email : null}
                            />
                        </Col>
                    </Row>
                    <GroupeBouton isHorizontal alignementHorizontal="right">
                        <Bouton
                            name="retour-accueil"
                            label="Annuler"
                            niveau="secondaire"
                            onClick={redirigerVersAccueil}
                        />
                        <Bouton
                            name="valider"
                            label="Valider"
                            niveau="primaire"
                            type="submit"
                            disabled={!formState.isValid}
                            isLoading={isLoading}
                        />
                    </GroupeBouton>
                </form>
            </div>
        </Container>
    );
};

DemandeLoginOublie.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    erreur: PropTypes.bool,
    message: PropTypes.string,
};

export default connect(
    (state) => {
        const { erreur, message, isLoading } = state.compte.recupererLogin.demande;
        return {
            erreur,
            message,
            isLoading,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(DemandeLoginOublie);
